import React, { Component } from 'react';

class HalfScreenTextParent extends Component {
  render(){
    var dynamicStyle = {};
    var p = this.props, roc = p.rateOfChange || 0.2, start = p.start || (window.innerHeight * p.reactKey * -(roc))
    var imgPositionY = Math.ceil(start + (p.scrollHeight * roc))
    // if(p.noFilter){var filterBackground = 'rgba(0, 0, 0, 0.0)'} else { var filterBackground = 'rgba(0, 0, 0, 0.5)'}

    var class1 = "col-lg-2 col-md-2 col-sm-0 col-xs-0"
    var class2 = "col-lg-10 col-md-10 col-sm-12 col-xs-12"

    if(p.columnClass && p.columnClass === 2){
      class1 = "col-lg-6 col-md-6 col-sm-6";
      class2 = "col-lg-6 col-md-6 col-sm-6";
    }

    return (
      <div className="background-filter-after" id={p.name} style={{backgroundImage: p.imageUrl, position: 'relative', backgroundPositionY: imgPositionY, ...style.frame}}>
        <div style={{width: '100%', height: '100%'}}>
          {/*<div className={class1} style={{height: '100%'}}>
                      {this.props.children[0]}
                    </div> */}
          <div className={class2} style={{height: '100%'}}>
            {this.props.children[1]}
          </div>
        </div>
      </div>
    )
  }
}

export default HalfScreenTextParent;

var style = {
  frame: {
    height: '60vh',
    width: '100%',
    backgroundSize: 'cover',
    willChange: 'scroll-position',
    backgroundPositionX: '50%',
    backgroundRepeat: 'no-repeat'
  }
}



// WEBPACK FOOTER //
// ./src/HalfScreenTextParent.js